// @ts-nocheck

import { BoomSpineAnimationsIds } from '../../../types/animations';
import { Locales } from '../../../types/common';
import {
  BoomHalloweenBackgroundImgPath,
  BoomHalloweenBannerDE,
  BoomHalloweenBannerEN,
  BoomHalloweenBannerES,
  BoomHalloweenBannerFR,
  BoomHalloweenBetslipIcon,
  BoomHalloweenFog,
  BoomHalloweenLogoImgPath,
  BoomHalloweenStep1IconPath,
  BoomHalloweenStep1ImgPath,
  BoomHalloweenStep2IconPath,
  BoomHalloweenStep2ImgPath,
  BoomHalloweenStep2WithBallImgPath,
  BoomHalloweenStep3IconPath,
  BoomHalloweenStep3ImgPath,
  BoomHalloweenStep3WithBallImgPath,
  BoomHalloweenStep4IconPath,
  BoomHalloweenStep4ImgPath,
  BoomHalloweenStep4WithBallImgPath,
  BoomHalloweenStep5IconPath,
  BoomHalloweenStep5ImgPath,
  BoomHalloweenStep5WithBallImgPath,
  BoomPatrickBackgroundImgPath,
  BoomPatrickBannerDE,
  BoomPatrickBannerEN,
  BoomPatrickBannerES,
  BoomPatrickBannerFR,
  BoomPatrickBetslipIcon,
  BoomPatrickFog,
  BoomPatrickLogoImgPath,
  BoomPatrickStep1IconPath,
  BoomPatrickStep1ImgPath,
  BoomPatrickStep2IconPath,
  BoomPatrickStep2ImgPath,
  BoomPatrickStep3IconPath,
  BoomPatrickStep3ImgPath,
  BoomPatrickStep4IconPath,
  BoomPatrickStep4ImgPath,
  BoomPatrickStep5IconPath,
  BoomPatrickStep5ImgPath,
  BoomStep2Balls,
  BoomStep3Balls,
  BoomStep4Balls,
  BoomStep5Balls,
  BoomValentineBackgroundImgPath,
  BoomValentineBannerDE,
  BoomValentineBannerEN,
  BoomValentineBannerES,
  BoomValentineBannerFR,
  BoomValentineBetslipIcon,
  BoomValentineFog,
  BoomValentineLogoImgDE,
  BoomValentineLogoImgEN,
  BoomValentineLogoImgES,
  BoomValentineLogoImgFR,
  BoomValentineStep1IconPath,
  BoomValentineStep1ImgPath,
  BoomValentineStep2IconPath,
  BoomValentineStep2ImgPath,
  BoomValentineStep3IconPath,
  BoomValentineStep3ImgPath,
  BoomValentineStep4IconPath,
  BoomValentineStep4ImgPath,
  BoomValentineStep5IconPath,
  BoomValentineStep5ImgPath,
} from '../assets/img';
import {
  BoomHalloweenSparkStep2ImgPath,
  BoomHalloweenSparkStep3ImgPath,
  BoomHalloweenSparkStep4ImgPath,
  BoomHalloweenSparkStep5ImgPath,
} from '../assets/spritesheets';
import { BoomSkinIds } from '../types/global';

export const BoomAssetsBySkinId = {
  [BoomSkinIds.HALLOWEEN]: {
    BackgroundImg: BoomHalloweenBackgroundImgPath,
    BetslipIcon: BoomHalloweenBetslipIcon,
    FogImgPath: BoomHalloweenFog,
    Logo: {
      Full: BoomHalloweenLogoImgPath,
    },
    Banners: {
      [Locales.FR]: BoomHalloweenBannerFR,
      [Locales.ES]: BoomHalloweenBannerES,
      [Locales.DE]: BoomHalloweenBannerDE,
      [Locales.EN]: BoomHalloweenBannerEN,
    },
    CompletedAnimation: BoomSpineAnimationsIds.BOOM_HALLOWEEN_EXPLOSION,
    StepSparkAnimationSettings: {
      columnCount: 2,
      rowCount: 4,
      duration: 20, //ms
    },
    StepAnimationByStepId: new Proxy(
      {},
      {
        get(origin, key) {
          if (!origin[key]) {
            return null;
          }
          return origin[key];
        },
      },
    ),
    StepIconsWithBallByStepId: new Proxy(
      {
        STEP_1: BoomHalloweenStep1ImgPath,
        STEP_2: BoomHalloweenStep2WithBallImgPath,
        STEP_3: BoomHalloweenStep3WithBallImgPath,
        STEP_4: BoomHalloweenStep4WithBallImgPath,
        STEP_5: BoomHalloweenStep5WithBallImgPath,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return BoomHalloweenStep1ImgPath;
          }
          return origin[key];
        },
      },
    ),
    StepSparkAnimationByStepId: new Proxy(
      {
        STEP_1: null,
        STEP_2: BoomHalloweenSparkStep2ImgPath,
        STEP_3: BoomHalloweenSparkStep3ImgPath,
        STEP_4: BoomHalloweenSparkStep4ImgPath,
        STEP_5: BoomHalloweenSparkStep5ImgPath,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return false;
          }
          return origin[key];
        },
      },
    ),
    SmallStepIconsByStepId: new Proxy(
      {
        STEP_1: BoomHalloweenStep1IconPath,
        STEP_2: BoomHalloweenStep2IconPath,
        STEP_3: BoomHalloweenStep3IconPath,
        STEP_4: BoomHalloweenStep4IconPath,
        STEP_5: BoomHalloweenStep5IconPath,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return '';
          }
          return origin[key];
        },
      },
    ),
    StepIconsByStepId: new Proxy(
      {
        STEP_1: BoomHalloweenStep1ImgPath,
        STEP_2: BoomHalloweenStep2ImgPath,
        STEP_3: BoomHalloweenStep3ImgPath,
        STEP_4: BoomHalloweenStep4ImgPath,
        STEP_5: BoomHalloweenStep5ImgPath,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return BoomHalloweenStep1ImgPath;
          }
          return origin[key];
        },
      },
    ),
  },
  [BoomSkinIds.VALENTINE]: {
    BackgroundImg: BoomValentineBackgroundImgPath,
    FogImgPath: BoomValentineFog,
    BetslipIcon: BoomValentineBetslipIcon,
    Logo: {
      [Locales.FR]: BoomValentineLogoImgFR,
      [Locales.ES]: BoomValentineLogoImgES,
      [Locales.DE]: BoomValentineLogoImgDE,
      [Locales.EN]: BoomValentineLogoImgEN,
      Full: '',
    },
    Banners: {
      [Locales.FR]: BoomValentineBannerFR,
      [Locales.ES]: BoomValentineBannerES,
      [Locales.DE]: BoomValentineBannerDE,
      [Locales.EN]: BoomValentineBannerEN,
    },
    CompletedAnimation: BoomSpineAnimationsIds.BOOM_VALENTINE_EXPLOSION,
    StepSparkAnimationSettings: {
      columnCount: 2,
      rowCount: 4,
      duration: 20, //ms
    },
    StepAnimationByStepId: new Proxy(
      {
        STEP_1: BoomSpineAnimationsIds.BOOM_VALENTINE_IDLE_STEP_1,
        STEP_2: BoomSpineAnimationsIds.BOOM_VALENTINE_IDLE_STEP_2,
        STEP_3: BoomSpineAnimationsIds.BOOM_VALENTINE_IDLE_STEP_3,
        STEP_4: BoomSpineAnimationsIds.BOOM_VALENTINE_IDLE_STEP_4,
        STEP_5: BoomSpineAnimationsIds.BOOM_VALENTINE_IDLE_STEP_5,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return null;
          }
          return origin[key];
        },
      },
    ),
    StepIconsWithBallByStepId: new Proxy(
      {
        STEP_1: null,
        STEP_2: BoomStep2Balls,
        STEP_3: BoomStep3Balls,
        STEP_4: BoomStep4Balls,
        STEP_5: BoomStep5Balls,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return null;
          }
          return origin[key];
        },
      },
    ),
    StepSparkAnimationByStepId: new Proxy(
      {
        STEP_1: null,
        STEP_2: BoomHalloweenSparkStep2ImgPath,
        STEP_3: BoomHalloweenSparkStep3ImgPath,
        STEP_4: BoomHalloweenSparkStep4ImgPath,
        STEP_5: BoomHalloweenSparkStep5ImgPath,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return false;
          }
          return origin[key];
        },
      },
    ),
    SmallStepIconsByStepId: new Proxy(
      {
        STEP_1: BoomValentineStep1IconPath,
        STEP_2: BoomValentineStep2IconPath,
        STEP_3: BoomValentineStep3IconPath,
        STEP_4: BoomValentineStep4IconPath,
        STEP_5: BoomValentineStep5IconPath,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return '';
          }
          return origin[key];
        },
      },
    ),
    StepIconsByStepId: new Proxy(
      {
        STEP_1: BoomValentineStep1ImgPath,
        STEP_2: BoomValentineStep2ImgPath,
        STEP_3: BoomValentineStep3ImgPath,
        STEP_4: BoomValentineStep4ImgPath,
        STEP_5: BoomValentineStep5ImgPath,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return BoomHalloweenStep1ImgPath;
          }
          return origin[key];
        },
      },
    ),
  },
  [BoomSkinIds.PATRICK]: {
    BackgroundImg: BoomPatrickBackgroundImgPath,
    FogImgPath: BoomPatrickFog,
    BetslipIcon: BoomPatrickBetslipIcon,
    Logo: {
      Full: BoomPatrickLogoImgPath,
    },
    Banners: {
      [Locales.FR]: BoomPatrickBannerFR,
      [Locales.ES]: BoomPatrickBannerES,
      [Locales.DE]: BoomPatrickBannerDE,
      [Locales.EN]: BoomPatrickBannerEN,
    },
    CompletedAnimation: BoomSpineAnimationsIds.BOOM_PATRICK_EXPLOSION,
    StepSparkAnimationSettings: {
      columnCount: 2,
      rowCount: 4,
      duration: 20, //ms
    },
    StepAnimationByStepId: new Proxy(
      {
        STEP_1: BoomSpineAnimationsIds.BOOM_PATRICK_IDLE_STEP_1,
        STEP_2: BoomSpineAnimationsIds.BOOM_PATRICK_IDLE_STEP_2,
        STEP_3: BoomSpineAnimationsIds.BOOM_PATRICK_IDLE_STEP_3,
        STEP_4: BoomSpineAnimationsIds.BOOM_PATRICK_IDLE_STEP_4,
        STEP_5: BoomSpineAnimationsIds.BOOM_PATRICK_IDLE_STEP_5,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return null;
          }
          return origin[key];
        },
      },
    ),
    StepIconsWithBallByStepId: new Proxy(
      {
        STEP_1: null,
        STEP_2: BoomStep2Balls,
        STEP_3: BoomStep3Balls,
        STEP_4: BoomStep4Balls,
        STEP_5: BoomStep5Balls,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return null;
          }
          return origin[key];
        },
      },
    ),
    StepSparkAnimationByStepId: new Proxy(
      {
        STEP_1: null,
        STEP_2: BoomHalloweenSparkStep2ImgPath,
        STEP_3: BoomHalloweenSparkStep3ImgPath,
        STEP_4: BoomHalloweenSparkStep4ImgPath,
        STEP_5: BoomHalloweenSparkStep5ImgPath,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return false;
          }
          return origin[key];
        },
      },
    ),
    SmallStepIconsByStepId: new Proxy(
      {
        STEP_1: BoomPatrickStep1IconPath,
        STEP_2: BoomPatrickStep2IconPath,
        STEP_3: BoomPatrickStep3IconPath,
        STEP_4: BoomPatrickStep4IconPath,
        STEP_5: BoomPatrickStep5IconPath,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return '';
          }
          return origin[key];
        },
      },
    ),
    StepIconsByStepId: new Proxy(
      {
        STEP_1: BoomPatrickStep1ImgPath,
        STEP_2: BoomPatrickStep2ImgPath,
        STEP_3: BoomPatrickStep3ImgPath,
        STEP_4: BoomPatrickStep4ImgPath,
        STEP_5: BoomPatrickStep5ImgPath,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return BoomHalloweenStep1ImgPath;
          }
          return origin[key];
        },
      },
    ),
  },
};
